import { EditType } from "@components/EditableCell"
import { NodeFormValues } from "@features/builder/NodeDrawer/NodeForm"
import {
  TableNodeHeader,
  TableNodeRow,
} from "@features/builder/NodeDrawer/NodeForm/NodeTableAccordion/types"
import { BaseGraphTableNode } from "@store/services/converter/types"
import { enqueueSnackbar } from "notistack"
import { UseFormReturn } from "react-hook-form"

export function getRows(
  properties: BaseGraphTableNode,
  headers: TableNodeHeader[],
  form: UseFormReturn<NodeFormValues>,
  onPropertiesUpdate?: (properties: BaseGraphTableNode) => void,
) {
  const formDisabled = form.formState.disabled

  let handleRemove: TableNodeRow[string]["onRemove"]

  if (!formDisabled) {
    handleRemove = (name) => {
      if (name === undefined) return

      if (properties.index.length === 1) {
        enqueueSnackbar("You can not remove last row", { variant: "error" })
        return
      }

      const rowIndex = properties.index.findIndex((rowName) => rowName === name)
      const updatedProperties = structuredClone(properties)
      updatedProperties.data.splice(rowIndex, 1)
      updatedProperties.index.splice(rowIndex, 1)
      onPropertiesUpdate?.(updatedProperties)
    }
  }

  const rows: TableNodeRow[] = []
  for (const i of properties.data.keys()) {
    const cells: TableNodeRow = {}
    for (const header of headers) {
      const newCell: (typeof cells)[string] = {
        editable: !formDisabled,
        editOnClick: true,

        value: properties.data[i]?.[header.idx] ?? "",
        name: i.toString(),
        errorMessage: "",
        type: EditType.Number,
      }

      // first cell with row name. Similar to header for columns
      const isFirstCell = header.idx === -1
      if (isFirstCell) {
        newCell.type = EditType.Text
        newCell.editable = !formDisabled

        const fieldName = `attributeProperties.index.${i}` as const
        newCell.name = fieldName
        newCell.value = form.getValues(fieldName) ?? ""
        newCell.sx = { fontWeight: "bold" }
        newCell.errorMessage = form.formState.errors.attributeProperties?.index?.[i]?.message ?? ""
        newCell.onBlur = (newValue) => {
          const newProperties = structuredClone(properties)
          newProperties.index[i] = newValue
          onPropertiesUpdate?.(newProperties)
        }
        newCell.onRemove = handleRemove
      } else {
        const fieldName = `attributeProperties.data.${i}.${header.idx}` as const
        newCell.name = fieldName
        newCell.value = form.getValues(fieldName) ?? ""
        newCell.errorMessage =
          form.formState.errors.attributeProperties?.data?.[i]?.[header.idx]?.message ?? ""

        newCell.onBlur = (newValue) => {
          if (isNaN(Number(newValue))) {
            form.setValue(fieldName, newCell.value as string)
            return
          }

          const newProperties = structuredClone(properties)
          if (newProperties.data[i]?.[header.idx] !== undefined) {
            newProperties.data[i][header.idx] = newValue
          }

          onPropertiesUpdate?.(newProperties)
        }
      }

      cells[header.key] = newCell
    }
    rows.push(cells)
  }
  return rows
}
